'use client'

import styles from "./Tutorial.module.css"

import Icon_1 from "@/assets/img/Icon_FrontPageTutorial_1.svg"
import Icon_2 from "@/assets/img/Icon_FrontPageTutorial_2.svg"
import Icon_3 from "@/assets/img/Icon_FrontPageTutorial_3.svg"
import { getTranslations } from "next-intl/server"
import LinkButton, { LinkButtonKind, LinkButtonSize } from "@/components/UI/Buttons/LinkButton/LinkButton"
import Icon from "@/components/UI/Icon/Icon"
import { useTranslations } from "next-intl"
import { useEffect, useMemo, useState } from "react"
import { useDynamicSignUpURL } from "@/apiUtilities/queries/useDynamicSignUpURL"
import { FEATURES } from "@/utils/constants"


export default function Tutorial() {

	const t = useTranslations("FrontPage.Tutorial")

	const [animate, setAnimate] = useState(true)

	useEffect(() => {
		const interval = setInterval(() => {
			setAnimate(false)
			setTimeout(() => setAnimate(true), 2000)
		}, 10000)

		return () => clearInterval(interval)
	}, [])

	const { data: dynamicSignUpURLData } = useDynamicSignUpURL({
			enabled: FEATURES.signUpExternal && FEATURES.signUpExternalDynamic
		})
	const signUpLink = useMemo(() => {
	    if (!FEATURES.signUp) return '/login'
		if (!FEATURES.signUpExternal) return '/#plans'
		if (!FEATURES.signUpExternalDynamic) {
		return process.env.NEXT_PUBLIC_FEATURE_SIGNUP_EXTERNAL_LINK ?? ''
		}
		return dynamicSignUpURLData?.url || ''
	}, [dynamicSignUpURLData])

	return (
		<section id={'tutorial'} className={styles.main} data-scroll-section>
			<h2 className="title1">
				{t('title')}
			</h2>
			<p className="title3">{t('subtitle')}</p>
			<div className={`${styles.animationWrapper} ${animate ? styles.animate : ''}`} >
				<div className={`${styles.container} ${styles.container1}`}>
					<div className={`${styles.iconWrapper} ${styles.icon1}`}>
						<Icon icon={Icon_1} className={`${styles.icon}`}></Icon>
					</div>
					<p>{t('icon1_text')}</p>
				</div>
				<div className={`${styles.container} ${styles.container2}`}>
					<div className={`${styles.iconWrapper} ${styles.icon2}`}>
						<Icon icon={Icon_2} className={`${styles.icon}`}/>
					</div>
					<p>{t('icon2_text')}</p>
				</div>
				<div className={`${styles.container} ${styles.container3}`}>
					<div className={`${styles.iconWrapper} ${styles.icon3}`}>
						<Icon icon={Icon_3} className={`${styles.icon}`}/>
					</div>
					<p>{t('icon3_text')}</p>
				</div>
			</div>
			<LinkButton href={signUpLink} internal={true} size={LinkButtonSize.LARGE} kind={LinkButtonKind.SUGGESTED}>{t('buttonText')}</LinkButton>
		</section>
	)
}